var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonStarsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0C74D6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,1.8c0.3,0.4,0.4,1,0.1,1.5c-1,1.8-1.5,3.8-1.5,5.9c0,6.9,5.6,12.4,12.5,12.4c0.9,0,1.8-0.1,2.6-0.3 c0.5-0.1,1.1,0.1,1.4,0.5c0.3,0.5,0.3,1.1-0.1,1.5c-2.7,3.3-6.8,5.3-11.1,5.2c-7.9,0-14.2-6.3-14.2-14.1c0-5.9,3.6-10.9,8.7-13 C10.6,1.2,11.2,1.4,11.6,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,6.7c0.1-0.2,0.3-0.3,0.5-0.2c0.1,0,0.2,0.1,0.2,0.2l0.7,2c0.3,0.9,1,1.6,1.9,1.9l2,0.7 c0.2,0.1,0.3,0.3,0.2,0.5c0,0.1-0.1,0.2-0.2,0.2l-2,0.7c-0.9,0.3-1.6,1-1.9,1.9l-0.7,2c-0.1,0.2-0.3,0.3-0.5,0.2 c-0.1,0-0.2-0.1-0.2-0.2l-0.7-2c-0.3-0.9-1-1.6-1.9-1.9l-2-0.7c-0.2-0.1-0.3-0.3-0.2-0.5c0-0.1,0.1-0.2,0.2-0.2l2-0.7 c0.9-0.3,1.6-1,1.9-1.9C19.1,8.7,19.8,6.7,19.8,6.7z M25,1.5c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.1,0.1,0.2,0.2l0.4,1.3 c0.2,0.6,0.7,1.1,1.2,1.2l1.3,0.4c0.1,0,0.2,0.2,0.2,0.3c0,0.1-0.1,0.1-0.2,0.2l-1.3,0.4c-0.6,0.2-1.1,0.7-1.2,1.2L25.5,8 c0,0.1-0.2,0.2-0.3,0.2C25.1,8.1,25,8.1,25,8l-0.4-1.3c-0.2-0.6-0.7-1.1-1.2-1.2L22,5c-0.1,0-0.2-0.2-0.2-0.3 c0-0.1,0.1-0.1,0.2-0.2l1.3-0.4c0.6-0.2,1.1-0.7,1.2-1.2L25,1.5L25,1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonStarsIcon);
export default __webpack_public_path__ + "static/media/moon_stars_icon.869c75d021a57d5be705cab35f6675e1.svg";
export { ForwardRef as ReactComponent };